"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingFilterPresetTransactionBooleanOperator = exports.LoyaltyReportingFilterPreset = exports.DataIntegrationNameDatabase = exports.BrowserReportingFilterPreset = exports.OperatingSystemReportingFilterPreset = exports.DeviceReportingFilterPreset = exports.ReportingFilterPresetGroupType = exports.ReportingFilterPresetURLOperator = exports.ReportingFilterPresetNumberOperator = exports.ReportingFilterPresetTextOperator = exports.ReportingFilterPresetConditionalOperator = exports.ReportingFilterPresetGroupName = void 0;
var ReportingFilterPresetGroupName;
(function (ReportingFilterPresetGroupName) {
    ReportingFilterPresetGroupName["First"] = "filter group 1";
    ReportingFilterPresetGroupName["Second"] = "filter group 2";
})(ReportingFilterPresetGroupName = exports.ReportingFilterPresetGroupName || (exports.ReportingFilterPresetGroupName = {}));
var ReportingFilterPresetConditionalOperator;
(function (ReportingFilterPresetConditionalOperator) {
    ReportingFilterPresetConditionalOperator["AND"] = "AND";
    ReportingFilterPresetConditionalOperator["OR"] = "OR";
})(ReportingFilterPresetConditionalOperator = exports.ReportingFilterPresetConditionalOperator || (exports.ReportingFilterPresetConditionalOperator = {}));
var ReportingFilterPresetTextOperator;
(function (ReportingFilterPresetTextOperator) {
    ReportingFilterPresetTextOperator["EqualTo"] = "is";
    ReportingFilterPresetTextOperator["NotEqualTo"] = "is not";
    ReportingFilterPresetTextOperator["Contains"] = "contains";
    ReportingFilterPresetTextOperator["DoesNotContain"] = "not contains";
})(ReportingFilterPresetTextOperator = exports.ReportingFilterPresetTextOperator || (exports.ReportingFilterPresetTextOperator = {}));
var ReportingFilterPresetNumberOperator;
(function (ReportingFilterPresetNumberOperator) {
    ReportingFilterPresetNumberOperator["EqualTo"] = "equal to";
    ReportingFilterPresetNumberOperator["NotEqualTo"] = "not equal to";
    ReportingFilterPresetNumberOperator["Between"] = "between";
    ReportingFilterPresetNumberOperator["LowerThan"] = "lower than";
    ReportingFilterPresetNumberOperator["GreaterThan"] = "greater than";
    ReportingFilterPresetNumberOperator["DoesNotContain"] = "not contains";
    ReportingFilterPresetNumberOperator["Contains"] = "contains";
})(ReportingFilterPresetNumberOperator = exports.ReportingFilterPresetNumberOperator || (exports.ReportingFilterPresetNumberOperator = {}));
var ReportingFilterPresetURLOperator;
(function (ReportingFilterPresetURLOperator) {
    ReportingFilterPresetURLOperator["URLIgnore"] = "url ignore";
    ReportingFilterPresetURLOperator["Contains"] = "contains";
    ReportingFilterPresetURLOperator["DoesNotContain"] = "not contains";
    ReportingFilterPresetURLOperator["Regex"] = "regex";
    ReportingFilterPresetURLOperator["NotRegex"] = "not regex";
    ReportingFilterPresetURLOperator["Exact"] = "exact";
    ReportingFilterPresetURLOperator["NotExact"] = "not exact";
})(ReportingFilterPresetURLOperator = exports.ReportingFilterPresetURLOperator || (exports.ReportingFilterPresetURLOperator = {}));
var ReportingFilterPresetGroupType;
(function (ReportingFilterPresetGroupType) {
    ReportingFilterPresetGroupType["Device"] = "device";
    ReportingFilterPresetGroupType["OPERATING_SYSTEM"] = "operatingSystem";
    ReportingFilterPresetGroupType["Browser"] = "browser";
    ReportingFilterPresetGroupType["Loyalty"] = "loyalty";
    ReportingFilterPresetGroupType["EcommerceVariable"] = "ecommerce variable";
    ReportingFilterPresetGroupType["Page"] = "page";
    ReportingFilterPresetGroupType["LandingPage"] = "landing page";
    ReportingFilterPresetGroupType["Date"] = "date";
    ReportingFilterPresetGroupType["ActionTracking"] = "action tracking";
    ReportingFilterPresetGroupType["CustomTracking"] = "custom tracking";
    ReportingFilterPresetGroupType["Geolocation"] = "geolocation";
    ReportingFilterPresetGroupType["VisitorAttributes"] = "visitor attributes";
    ReportingFilterPresetGroupType["TransactionPaymentMethod"] = "transaction payment method";
    ReportingFilterPresetGroupType["TransactionShipmentMethod"] = "transaction shipment method";
    ReportingFilterPresetGroupType["TransactionItemCategory"] = "transaction item category";
    ReportingFilterPresetGroupType["TransactionCurrency"] = "transaction currency";
    ReportingFilterPresetGroupType["TransactionRevenue"] = "transaction revenue";
    ReportingFilterPresetGroupType["TransactionItemPrice"] = "transaction item price";
    ReportingFilterPresetGroupType["TransactionItemQuantity"] = "transaction item quantity";
    ReportingFilterPresetGroupType["TransactionItemName"] = "transaction item name";
    ReportingFilterPresetGroupType["TransactionShippingValue"] = "transaction shipping value";
    ReportingFilterPresetGroupType["TransactionTaxRate"] = "transaction tax rate";
    ReportingFilterPresetGroupType["TransactionTotalItemsQuantity"] = "transaction total items quantity";
    ReportingFilterPresetGroupType["TransactionBuyer"] = "transaction buyer";
    ReportingFilterPresetGroupType["TransactionCouponCode"] = "transaction coupon code";
    ReportingFilterPresetGroupType["TransactionID"] = "transaction transaction id";
    ReportingFilterPresetGroupType["TransactionItemCode"] = "transaction item code";
    ReportingFilterPresetGroupType["TransactionCustomVariable"] = "transaction custom variable";
    ReportingFilterPresetGroupType["DataIntegration"] = "data integration";
})(ReportingFilterPresetGroupType = exports.ReportingFilterPresetGroupType || (exports.ReportingFilterPresetGroupType = {}));
// Define Filter
var DeviceReportingFilterPreset;
(function (DeviceReportingFilterPreset) {
    DeviceReportingFilterPreset["Desktop"] = "desktop";
    DeviceReportingFilterPreset["MobilePhone"] = "mobile phone";
    DeviceReportingFilterPreset["Tablet"] = "tablet";
})(DeviceReportingFilterPreset = exports.DeviceReportingFilterPreset || (exports.DeviceReportingFilterPreset = {}));
// Define Filter
var OperatingSystemReportingFilterPreset;
(function (OperatingSystemReportingFilterPreset) {
    OperatingSystemReportingFilterPreset["Windows"] = "Windows";
    OperatingSystemReportingFilterPreset["Linux"] = "Linux";
    OperatingSystemReportingFilterPreset["OSX"] = "OS X";
    OperatingSystemReportingFilterPreset["iOS"] = "iOS";
    OperatingSystemReportingFilterPreset["Android"] = "Android";
})(OperatingSystemReportingFilterPreset = exports.OperatingSystemReportingFilterPreset || (exports.OperatingSystemReportingFilterPreset = {}));
// Browser Filter
var BrowserReportingFilterPreset;
(function (BrowserReportingFilterPreset) {
    BrowserReportingFilterPreset["Chrome"] = "chrome";
    BrowserReportingFilterPreset["ChromeMobile"] = "chrome mobile";
    BrowserReportingFilterPreset["Firefox"] = "firefox";
    BrowserReportingFilterPreset["Safari"] = "safari";
})(BrowserReportingFilterPreset = exports.BrowserReportingFilterPreset || (exports.BrowserReportingFilterPreset = {}));
// Data Integration name Database
var DataIntegrationNameDatabase;
(function (DataIntegrationNameDatabase) {
    DataIntegrationNameDatabase["GA4"] = "ga4audiences";
    DataIntegrationNameDatabase["Segment"] = "segmentio";
    DataIntegrationNameDatabase["Mixpanel"] = "mixpanel";
    DataIntegrationNameDatabase["Heap"] = "heap";
    DataIntegrationNameDatabase["Tealium"] = "tealium";
    DataIntegrationNameDatabase["Fullstory"] = "fullstory";
    DataIntegrationNameDatabase["Ysance"] = "ysance";
    DataIntegrationNameDatabase["Krux"] = "krux";
    DataIntegrationNameDatabase["TagCommander"] = "tagCommander";
    DataIntegrationNameDatabase["BlueKai"] = "blueKai";
    DataIntegrationNameDatabase["Weborama"] = "weborama";
    DataIntegrationNameDatabase["Adobe"] = "adobe";
    DataIntegrationNameDatabase["Advalo"] = "advalo";
    DataIntegrationNameDatabase["Eulerian"] = "eulerian";
    DataIntegrationNameDatabase["Air360"] = "air360";
    DataIntegrationNameDatabase["Dotaki"] = "dotaki";
    DataIntegrationNameDatabase["Piano"] = "pianoAnalytics";
})(DataIntegrationNameDatabase = exports.DataIntegrationNameDatabase || (exports.DataIntegrationNameDatabase = {}));
// Loyalty Filter
var LoyaltyReportingFilterPreset;
(function (LoyaltyReportingFilterPreset) {
    LoyaltyReportingFilterPreset["NewVisitors"] = "new visitors";
    LoyaltyReportingFilterPreset["ReturningVisitors"] = "returning visitors";
})(LoyaltyReportingFilterPreset = exports.LoyaltyReportingFilterPreset || (exports.LoyaltyReportingFilterPreset = {}));
// Transaction Boolean Groups
var ReportingFilterPresetTransactionBooleanOperator;
(function (ReportingFilterPresetTransactionBooleanOperator) {
    ReportingFilterPresetTransactionBooleanOperator["Contains"] = "contains";
    ReportingFilterPresetTransactionBooleanOperator["NotContains"] = "not contains";
})(ReportingFilterPresetTransactionBooleanOperator = exports.ReportingFilterPresetTransactionBooleanOperator || (exports.ReportingFilterPresetTransactionBooleanOperator = {}));
//# sourceMappingURL=types.js.map